module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/babel-preset-react-app/node_modules/babel-runtime/regenerator/index.js
// module id = 126
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 12